import axiosInstance from '../services/AxiosInstance';

export const getTransactionSettings = async () => {
  const response = await axiosInstance.get("transaction-settings/list");
  return response.data;
};

export const saveTransactionSettings = async (data) => {
  const response = await axiosInstance.put("transaction-settings/update/1", data); // or PUT
  return response.data;
};